module.exports = __webpack_public_path__ + "static/media/tick.def3de95.svg";